import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const CustomScrollbarWrapper = styled('div')`
  width: 100%;
  position: relative;
`
export const CustomScrollbarWrapperInner = styled('div')`
  display: flex;
  width: 100%;
  border: 1px solid ${colors.backgroundGrey};
  border-radius: 4px;
  background-color: ${colors.lightGrey2};
`

export const CustomScrollbarContainer = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  place-items: center;
`

export const CustomScrollbarTrackBox = styled('div')`
  display: block;
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;
  height: 28px;
  padding: 4px 0;
`

export const CustomScrollbarTrack = styled('div')`
  right: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
  height: 24px;
  z-index: 2;
`
export const CustomScrollbarThumb = styled('div')`
  border-radius: 2px;
  background-color: ${colors.white};
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
  position: absolute;
  height: 20px;
  text-align: center;
  color: #a7a7a7;
  font-size: 12px;
  line-height: 20px;
`
export const CustomScrollbarLeftButton = styled(Button)`
  width: 30px;
  height: 28px;
  border: none;
  background-color: ${colors.lightGrey2};
`
export const CustomScrollbarLeftArrow = styled(ArrowLeftIcon)`
  height: 38px;
  width: 38px;
  color: ${colors.darkGray2};
`
export const CustomScrollbarRightButton = styled(Button)`
  width: 30px;
  height: 28px;
  border: none;
  background-color: ${colors.lightGrey2};
`

export const CustomScrollbarRightArrow = styled(ArrowRightIcon)`
  height: 38px;
  width: 38px;
  color: ${colors.darkGray2};
`
